import { render, staticRenderFns } from "./occupancy.vue?vue&type=template&id=67ce909b&scoped=true&"
import script from "./occupancy.vue?vue&type=script&lang=js&"
export * from "./occupancy.vue?vue&type=script&lang=js&"
import style0 from "./occupancy.vue?vue&type=style&index=0&id=67ce909b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce909b",
  null
  
)

export default component.exports